export const setAllFeatureTogglesForUserAction =
  'setFeatureTogglesForUserAction';
export const setAllFeatureTogglesForLoggedInUserAction =
  'setFeatureToggleForCurrentUserAction';
